import React from 'react';
import styled from '@emotion/styled';
import ExternalVideoMediaComponent from '../media/media.externalvideo.component';
import { Media } from '..';
import { Grid } from '../../style';

const FullscreenImageComponent = (props) => (
    <div id="FullscreenImageComponent">
        {props.isFullscreen ? 
        <FullscreenImageComponentCode {...props}/>
        :
        <div className="wrapper">
            <div className="container-fluid">
                <FullscreenImageComponentCode {...props}/>
            </div>
        </div>
    }
    </div>
);

const FullscreenImageComponentCode = ({
    image,
    video,
    loop,
    backgroundColor,
    textColor,
    textOverlay,
    imageBackgroundColor,
    showFullscreenControl,
    showMuteControl
}) => (
    <Grid.Wrapper
        backgroundColor={backgroundColor && backgroundColor.hex}
        textColor={textColor && textColor.hex}>
        <Grid.Overflow>
            <ImageContainer>
                <Media
                    backgroundColor={
                        imageBackgroundColor && imageBackgroundColor.hex
                    }
                    video={video}
                    image={image}
                    textOverlay={textOverlay}
                    loop={loop}
                    showFullscreenControl={showFullscreenControl}
                    showMuteControl={showMuteControl}
                />
            </ImageContainer>
        </Grid.Overflow>
    </Grid.Wrapper>
);

const ImageContainer = styled.div`
    font-size: 0;
    max-width: 100%;
    margin: 0 auto;
    img {
        max-width: 100%;
    }

    width: 100%;
`;

export default FullscreenImageComponent;
